module.exports = __webpack_public_path__ + "img/pl-flag.beb64186.svg";